import type { CanvasTab } from '../components/canvas/CanvasContext';

/**
 * When the agent creates a crate (or other canvas-worthy result) in the
 * renderer bridge, the dashboard canvas host needs to open without the DJ
 * clicking a link. This is the hand-off from the bridge to DashboardPage.
 */

type Listener = (tab: CanvasTab) => void;

const listeners = new Set<Listener>();

export const publishAgentCanvas = (tab: CanvasTab): void => {
  for (const listener of listeners) listener(tab);
};

export const subscribeToAgentCanvas = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
